function footer() {
    const currentYear = new Date().getFullYear();
    document.getElementById("current-year").textContent = currentYear;
}
